import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { Storage } from "@ionic/storage";
import { AppVersion } from "@ionic-native/app-version";
import { Platform } from "ionic-angular";
import { InAppBrowser } from "@ionic-native/in-app-browser";

@Injectable()

export class DataService {

  constructor(
    public api: ApiService,
    public storage: Storage,
    private appVersion: AppVersion,
    public iab: InAppBrowser,
    private platform: Platform
  ) {}

  public getAppVersionNumber(){
    return (this.platform.is('cordova') ? this.appVersion.getVersionNumber() : 'UNKNOWN');
  }

  public addCompletedWorkorder(data){
    data.app_version_number = this.getAppVersionNumber();
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('completed_workorders_' + user_id).then((val) => {
          // if local storage already exists
          let completed_workorders = (val ? JSON.parse(val) : []);
          completed_workorders.push(data);
          this.storage.set('completed_workorders_' + user_id, JSON.stringify(completed_workorders)).then(() => {
            resolve();
          }).catch(() => {
            reject();
          });
        }).catch(() => {
          // if local storage does not exist yet
          let completed_workorders = [];
          completed_workorders.push(data);
          this.storage.set('completed_workorders_' + user_id, JSON.stringify(completed_workorders)).then(() => {
            resolve();
          }).catch(() => {
            reject();
          });
        });
      }).catch(() => {
        reject();
      });
    });
  }

  public getCompletedWorkorders(){
    return new Promise((resolve) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('completed_workorders_' + user_id).then((val) => {
          let completed_workorders = (val ? JSON.parse(val) : []);
          resolve(completed_workorders);
        }).catch(() => {
          resolve([]);
        });
      }).catch(() => {
        resolve([]);
      });
    });
  }

  public sendCompletedWorkorders(){
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('completed_workorders_' + user_id).then((val) => {
          let completed_workorders = (val ? JSON.parse(val) : []);
          this.api.setWorkorders(completed_workorders).then(() => {
            this.storage.set('completed_workorders_' + user_id, JSON.stringify([])).then(() => {
              resolve();
            }).catch(() => {
              reject();
            });
          }).catch(() => {
            reject();
          });
        });
      });
    });
  }

  public updateUnitBrands(){
    return new Promise((resolve, reject) => {
      this.api.getUnitBrands().then((data) => {
        this.storage.set('unitbrands', JSON.stringify(data)).then(() => {
          resolve();
        }).catch((error) => {
          reject(error);
        })
      }).catch((error) => {
        reject(error);
      });
    });
  }

  public getUnitBrands(){
    return new Promise((resolve) => {
      this.storage.get('unitbrands').then((val) => {
        let unitbrands = (val ? JSON.parse(val) : []);
        resolve(unitbrands);
      }).catch(() => {
        resolve([]);
      });
    });
  }

  public updateDevices(){
    return new Promise((resolve, reject) => {
      this.api.getDevices().then((data) => {
        this.storage.set('devices', JSON.stringify(data)).then(() => {
          resolve();
        }).catch((error) => {
          reject(error);
        })
      }).catch((error) => {
        reject(error);
      });
    });
  }

  public getDevices(){
    return new Promise((resolve) => {
      this.storage.get('devices').then((val) => {
        let devices = (val ? JSON.parse(val) : []);
        resolve(devices);
      }).catch(() => {
        resolve([]);
      });
    });
  }

  public setDefaultDevice(device){
    this.storage.set('default_device', JSON.stringify(device));
  }

  public getDefaultDevice(){
    return new Promise((resolve) => {
      this.storage.get('default_device').then((val) => {
        let device = (val ? JSON.parse(val) : null);
        resolve(device);
      }).catch(() => {
        resolve(null);
      });
    });
  }

  public updateCompanyUsers(){
    return new Promise((resolve, reject) => {
      this.api.getCompanyUsers().then((data) => {
        this.storage.set('company_users', JSON.stringify(data)).then(() => {
          resolve();
        }).catch((error) => {
          reject(error);
        })
      }).catch((error) => {
        reject(error);
      });
    });
  }

  public getCompanyUsers(){
    return new Promise((resolve) => {
      this.storage.get('company_users').then((val) => {
        let company_users = (val ? JSON.parse(val) : []);
        resolve(company_users);
      }).catch(() => {
        resolve([]);
      });
    });
  }

  public getWorkorderTypeString(workorder_type){
    let title = 'Werkorder';
    switch(workorder_type){
      case '1':
        title = '1e inbedrijfstelling';
        break;
      case '2':
        title = 'Onderhoud';
        break;
      case '3':
        title = 'Storing';
        break;
      case '4':
        title = 'Toestel verwijderen';
        break;
      case '5':
        title = 'Aanmelden nieuwe installatie';
        break;
      case '6':
        title = 'Garantiekaart invullen';
        break;
      case '7':
        title = 'Buitenbedrijfstelling';
        break;
    }
    return title;
  }

  public openFeedbackForm() {
    let url = 'https://www.mijninstallatiepas.nl/management/pub/embedfeedbackform';
    let user = this.api.getLoggedInUser();
    url += '/' + user.company_user_id + '/' + user.feedback_token;
    this.iab.create(url, '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/services/data.service.ts